import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { loaderUnitServicesPage } from '@/loaders/unit.services.loader';
import { UnitServicesPage } from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/services';

export const Route = createFileRoute('/_authenticated/_account/units/$endCustomerUnitId/services/')({
  component: UnitServicesPage,
  errorComponent: ErrorBoundary,
  loader: loaderUnitServicesPage,
});
